<template>
  <div>
    <the-button-back />
    <form-component />

    <button-create />
  </div>
</template>

<script>
import TheButtonBack from '@/lib/TheButtonBack'
import FormComponent from './FormComponent/index'
import ButtonCreate from './ButtonCreate'

export default {
  components: {
    TheButtonBack,
    FormComponent,
    ButtonCreate
  }
}
</script>
